import React from 'react'
import noop from 'lodash/noop'
import omit from 'lodash/omit'
import { Mutation } from 'react-apollo'
import { TableRow, TableCell } from '@mui/material'
import EditButton from '../../../common/iconButtons/EditButton'
import DeleteButton from '../../../common/iconButtons/DeleteButton'
import { deleteNightTask } from '../../station/stationQueries'
import type { NightTask } from '../../station/stationTypes'
import css from './nightTaskTable.css'
type NightTaskRowProps = {
  data: NightTask
  onEdit: (...args: Array<any>) => any
  onDelete: (...args: Array<any>) => any
}

const NightTaskRow = ({ data, onEdit, onDelete }: NightTaskRowProps) => (
  <TableRow>
    <TableCell className={css.tableCell}>{data.name}</TableCell>
    <TableCell className={css.actionsCell}>
      <EditButton onClick={() => (data.id ? onEdit(omit(data, ['__typename'])) : noop)} />
      <Mutation mutation={deleteNightTask}>
        {(onMutate) => <DeleteButton onClick={() => (data.id ? onDelete(onMutate, data.id) : noop)} />}
      </Mutation>
    </TableCell>
  </TableRow>
)

export default NightTaskRow
